window.TL_CUSTOM = {
    onBeforeInit: async (context) => {
        console.log('onBeforeInit');
        if (ADAPTER_CONFIGS) {
            ADAPTER_CONFIGS.prestige.placements.product_form.selector = ".product-info__block-item[data-block-type='complementary-products']";
        }
    },
    onAfterInit: async ({ widget }) => {
        
    },
};
